import { ExternalUser, ExternalUserRole } from "models/customers/customers";
import SummaryModule from "../summaryModule/SummaryModule";

import "./ExternalUsersSummary.scss";

type Props = {
  users: ExternalUser[];
};

export default function ExternalUsersSummary({ users }: Props) {
  const roleTextMap: Record<ExternalUserRole, string> = {
    [ExternalUserRole.Admin]: "Kundadmin",
    [ExternalUserRole.User]: "Användare",
    [ExternalUserRole.Accounting]: "Redovisning",
    [ExternalUserRole.Payroll]: "Lön",
  };
  const getRoleText = (roles: ExternalUserRole[]) => {
    return roles.map(role => roleTextMap[role] || "").join(", ");
  };

  return (
    <SummaryModule
      moduleTitle="Kundanvändare"
      info="Redigera kundanvändare och roller"
    >
      <div className="overflow-sm-auto">
        <table className="table">
        <thead>
          <tr>
            <th>Namn</th>
            <th>E-post</th>
            <th>Roll</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            return (
              <tr key={user.email}>
                <td>{user.givenName + " " + user.surName}</td>
                <td>{user.email}</td>
                <td>{getRoleText(user.roles)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    </SummaryModule>
  );
}